import { Fragment } from 'react';
import { MultiSelectBoxNew } from '../../components/SelectBox/MultiSelectBox';

const FilterUtilization = ({ data }) => {
	const {
		showFilter,
		setShowFilter,
		handleFilterSubmit,
		handleClear,
		clinicData,
		selectedClinic,
		setSelectedClinic
	} = data;

	return (
		<Fragment>
			{!showFilter ? (
				<div className='filter__header' >
					<button id="filterHide" className='filter__heading--btn' onClick={() => setShowFilter(!showFilter)}>
						Hide Filter
					</button>
				</div>
			) : (
				<div className='filter__header' style={{ marginBottom: '20px' }}>
					<button id="filterShow" className='filter__heading--btn' onClick={() => setShowFilter(!showFilter)}>
						Show Filter
					</button>
				</div>
			)}
			<div className='filter' style={{ height: showFilter ? 0 : '10rem', overflow: 'auto' }}>
				<div className='filter__inputs' style={{ maxWidth: '850px' }}>
					<MultiSelectBoxNew
						multiple={true}
						label=''
						placeholder="Select/Search Clinic"
						icon={false}
						errorMessage={selectedClinic.error}
						value={selectedClinic.value.length ? [...selectedClinic.value] : null}
						setSendToData={setSelectedClinic}
						onChange={event => {
							setSelectedClinic({ value: event, error: '' });
						}}
						children={clinicData}
						closeMenuOn={false}
					></MultiSelectBoxNew>

					<div className='filter__input--buttonContainer'>
						<button className='filter__input--button' id='searchBtn' onClick={handleFilterSubmit}>
							Search
						</button>
						<button className='filter__input--button' id='clearBtn' onClick={handleClear}>
							Clear
						</button>
					</div>
				</div>

				<div style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'row',
					gap: 20
				}}>


				</div>
			</div>
		</Fragment >
	);
};

export default FilterUtilization;
